import { render, staticRenderFns } from "./guideArticle.vue?vue&type=template&id=4be2cb2b&scoped=true"
import script from "./guideArticle.vue?vue&type=script&lang=js"
export * from "./guideArticle.vue?vue&type=script&lang=js"
import style0 from "./guideArticle.vue?vue&type=style&index=0&id=4be2cb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2cb2b",
  null
  
)

export default component.exports